import axios from "axios";

export const createResultsFromGeocode = (geocodingData) => {
    const geoCodeResults = {
        DisplayName: "ArcGIS Geocoder",
        Id: "ArcGIS Geocoder",
        Features: [],
    };
    geocodingData.candidates.forEach((result) => {
        geoCodeResults.Features.push(result.attributes.Match_addr);
    });
    return [geoCodeResults];
};

/**
 * Takes in parameters to give to the ArcGIS Rest Geocode endpoint and creates a URL
 * @param {Array<Object>} geocoderConfig Array of geocoding endpoints from config file
 * @param {Object} mapConfig Map configuration from state
 * @param {String} searchValue Value to search for
 * @returns {String} Request URL
 */
export const createEsriGeocodeURL = (geocoderConfig, mapConfig, searchValue) => {
    //https://developers.arcgis.com/rest/geocode/api-reference/geocoding-find-address-candidates.htm
    const ArcGISWorldGeocoderURL =
        "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer";
    const fullExentArr = mapConfig.fullExtent.split(",");
    const searchExtent = {
        xmin: fullExentArr[0],
        ymin: fullExentArr[1],
        xmax: fullExentArr[2],
        ymax: fullExentArr[3],
        spatialReference: { wkid: mapConfig.projection.split(":")[1] },
    };
    if (geocoderConfig) {
        return `${
            geocoderConfig.ConnectionString
        }/findAddressCandidates?f=json&${encodeURIComponent(
            geocoderConfig.GlobalSearchKey
        )}=${encodeURIComponent(
            searchValue
        )}&maxLocations=10&outFields=Match_addr,Score,PlaceName,LongLabel,Phone&outsr=${
            mapConfig.projection.split(":")[1]
        }&searchExtent=${encodeURIComponent(JSON.stringify(searchExtent))}`;
    } else {
        return `${ArcGISWorldGeocoderURL}/findAddressCandidates?f=json&address=${encodeURIComponent(
            searchValue
        )}&sourceCountry=USA,CAN,PRI,MEX&maxLocations=10&outFields=*&outsr=${
            mapConfig.projection.split(":")[1]
        }&searchExtent=${encodeURIComponent(JSON.stringify(searchExtent))}`;
    }
};

export const ArcGISGeocoder = async (geocoderConfig, mapConfig, searchValue) => {
    try {
        const reqURL = createEsriGeocodeURL(geocoderConfig, mapConfig, searchValue);
        const resp = await axios.get(reqURL, {
            headers: {},
        });
        return resp.data;
    } catch (error) {
        console.log(error);
        return "geocode error";
    }
};

const GoogleGeocoder = (searchValue) => {};
const BingGeocoder = (searchValue) => {};
